import { RSAA, RSAAction } from 'redux-api-middleware';

import * as types from './endpointsActionTypes';

export const fetchEndpoints = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: 'endpoints',
    method: 'GET',
    types: [types.FETCH_ENDPOINTS_REQUEST, types.FETCH_ENDPOINTS_SUCCESS, types.FETCH_ENDPOINTS_FAILURE],
  },
});
